import React, { useEffect, useState } from "react";
import { useStoreState } from "easy-peasy";
import { useLocation } from "react-router-dom";
import marketing from "../../services/marketing";
import { tcGenerator } from '../../services/tcGenerator';
import ErrorModal from '../body/forms/components/ErrorModal'
import LoadingModal from '../body/forms/components/LoadingModal';
import { BANK, FLOW, PRODUCT } from "../../models/websiteTypesConstants";

function AppSiteFooter() {
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const productSettings = useStoreState(
    (state) => state.siteSettingsModel.productSettings
  );
  const defaultPrivacyUrl = useStoreState((state) => state.siteSettingsModel.defaultPrivacyUrl);

  const [customerService] = useState("tel:" + productSettings.CustomerService);
  const utm = new marketing();
  const routingSettings = useStoreState(
    (state) => state.routingSettingsModel.routingSettings
  );

  const mainSettings = useStoreState(
    (state) => state.siteSettingsModel.mainSettings
  );
  const location = useLocation();
  const applicant = useStoreState((state) => state.applicantModel.applicant);
  const applicationResult = useStoreState(
    (state) => state.applicationResultModel.applicationResult
  );
  const [pCode, setPCode] = useState(mainSettings.ProductCode);
  const MainPath          = useStoreState(state => state.siteSettingsModel.MainPath);

  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const closeError = () => setErrorShow(false);
  const [loading, setLoading] = useState(false);

  const handleViewTerms = async (e) => {
    if (e) e.preventDefault();

    setLoading(true);
    try {
        const { fileContent, hasErrors, errorMessage } = await tcGenerator(pCode);
        setLoading(false);
        if (hasErrors) {
            setErrorMessage(errorMessage);
            setErrorShow(true);
            return;
        }
        const byteCharacters = atob(fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "_blank");
    } catch (err) {
        setLoading(false)
        setErrorMessage(`${err.message}`);
        setErrorShow(true);
    }
};

const handleRetry = () => {
  setErrorShow(false);
  handleViewTerms();
};

  useEffect(() => {
    if (applicant.ProductCode || applicant.ProductCode !== "") {
      setPCode(applicant.ProductCode);
    }

  }, [applicant.ProductCode]);

  useEffect(() => {
    if (applicationResult.product_code || applicationResult.product_code !== "" || applicationResult.alternate_product_code === null) {
      setPCode(applicationResult.product_code);
    }

  }, [applicationResult.product_code, applicationResult.alternate_product_code]);

  useEffect(() => {
        if (applicationResult.alternate_product_code && applicationResult.alternate_product_code !== "" && applicationResult.alternate_product_code !== null) {
            setPCode(applicationResult.alternate_product_code);
        }
       
  }, [applicationResult.alternate_product_code])

  return (
    <div className="container">
    <LoadingModal show={loading} message="Loading Terms & Conditions..." />
    <ErrorModal size='sm' show={errorShow} message={errorMessage} closeError={closeError} onRetry={handleRetry} />
      {(mainSettings.Flow === FLOW.CS) && (
        <p>
          * A Pre-approved credit card offer means you meet the initial credit card and underwriting criteria and your 
          application may be approved for this {brandSettings.ProductName}<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> Mastercard<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> offer 
          if you continue to meet this criteria. See Rates, Fees, Costs and Limitations.  
        </p>
      )}
      <p className="footer-links">
        {routingSettings.PrivacyFooter && (
          <>
            <a
              onClick={() => {
                utm.updateSessionReport("privacyLink");
              }}
              href={brandSettings.ProductName === PRODUCT.Grand.bank ? productSettings.PrivacyUrl : defaultPrivacyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"}   
            >
              Privacy
            </a>
            {(routingSettings.FaqFooter || routingSettings.TermsFooter) && (
              <span> | </span>
            )}
          </>
        )}
        {routingSettings.FaqFooter && (
          <>
            <a
              onClick={(e) => {
                utm.updateSessionReport("faqLink");
              }}
              target="_blank"
              href={productSettings.FaqUrl}
              rel="noopener noreferrer"
              className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"} 
            >
              FAQ
            </a>
            {routingSettings.TermsFooter && <span> | </span>}
          </>
        )}
      {mainSettings.Flow === FLOW.DM ?
        routingSettings.TermsFooter ? (
          routingSettings.TermsFooterCDN ? (
            <a href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer" className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"}>Terms & Conditions</a>
          ) :
            (
              (applicant.IsRollUpCode && ['/terms', '/decision', '/pendinfo'].some(p => window.location.href.includes(p))) ? 
              <a href='/tc' target="_blank" className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"} onClick={() => {utm.updateSessionReport("termsLink"); localStorage.setItem("TCProductCode", applicant.ProductCode)}} >Terms & Conditions</a> 
              :
              <a 
                onClick={ (e) => {e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsButton"); localStorage.setItem("TCProductCode", pCode);}}
                href="#" target="_blank" rel="noopener noreferrer" className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"} 
              >
                Terms & Conditions
              </a>
            )
        ) : null 
        :
        routingSettings.TermsFooter ? (
          routingSettings.TermsFooterCDN ? (
            <a
              onClick={() => {
                utm.updateSessionReport("privacyLink");
              }}
              href={productSettings.TermsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"}
            >
              Terms & Conditions
            </a>
          ) : 
          (
            <a
              onClick={ (e) => {e.preventDefault(); utm.updateSessionReport("termsButton"); handleViewTerms(); localStorage.setItem("TCProductCode", pCode)} }
              href="#"
              className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"} 
            >
              Terms & Conditions
            </a>
          )
        ) : null}
      </p>
      
      
      <>
        <p className="footer-links">
          Have a Question? Call Customer Service at{" "}
          <a
            href={customerService}
            className={brandSettings.ProductName === PRODUCT.Reflex ? "footer-links-reflex" : "footer-links"}
          >
            {brandSettings.ProductName === PRODUCT.Grand.bank ? '1-844-697-5871' : '1-866-449-4514' }  
          </a>
        </p>
        <div className="footer-hours">
          <p> Monday - Friday: 7am - 12am</p>
          <p> Saturday - Sunday: 8am - 8pm</p>
          <p> Eastern Standard Time</p>
        </div>
      </>
      <p>
        {
          brandSettings.ProductName.toLowerCase() === 'fit' ? `${brandSettings.ProductName.toUpperCase()}™` 
            : (
                <>
                  {brandSettings.ProductName === PRODUCT.Grand.bank 
                  ? <>Grand.bank<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> Plus Credit Card</>
                  : <>
                      {brandSettings.ProductName}
                      <span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span>
                    </>
                  }
                  
                </>
              )
        } is issued by{" "}
        {brandSettings.BankName === BANK.Grand.bank
        ? <>
          Grand Bank for Savings, FSB
        </> 
        : brandSettings.BankName}, pursuant to a license from Mastercard<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> International.
      </p>
      {
        brandSettings.BankName === BANK.Grand.bank 
        ? (
          <p>Credit card issued by Grand Bank for Savings, FSB (Grand.bank<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span>), 
            Member FDIC. The credit card is not a 
            deposit and is not FDIC-insured. Credit card servicing provided by Continental Finance Company, LLC, 
            an affiliate of Grand Bank for Savings, FSB. 
          </p>
        )
        : (
          <p>
            Continental Finance Company, LLC provides services for your Account but is not a bank. 
            The bank issuing your card will be identified on the back of your Mastercard<span style={{verticalAlign: "super", fontSize: "0.75em"}}>&reg;</span> and 
            in your Cardholder Agreement, which governs your use of the Account.
          </p>
        )
      }
      <p>
        All trademarks not belonging to Continental Finance Company, LLC are the property of their respective owners. 
      </p>
      <p>
        THIS IS A CREDIT SOLICITATION ONLY. CONTINENTAL FINANCE COMPANY, LLC IS NOT THE LENDER.
        INFORMATION RECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR CREDIT INQUIRY.
      </p>
      <p>
        Obtaining Your Card: The USA PATRIOT Act is a federal law that requires all financial institutions to obtain, 
        verify and record information that identifies each person who opens a Card Account. 
        What this means for you: When you open a Card Account, we will ask for your name, address, date of birth 
        and other information that will allow us to reasonably identify you.
        We may also ask to see your driver's license or other identifying documents at any time.
      </p>
      <p><small>©{new Date().getFullYear()} Continental Finance Company, LLC All rights reserved.</small></p>
      <p className="mb-0">
        <img alt="" src={brandSettings.FooterLogo} />
      </p>
      <p className="text-right mb-0">
        <small>
          {
            ((location.pathname+"/") === ("/"+MainPath) || (location.pathname+"/") === MainPath || (location.pathname.replace("/","") === MainPath.replace('/', ''))) ?
            <>
              Version {process.env.REACT_APP_VERSION || "local"}
            </>
            : 
            <></>
          }
       
        </small>
      </p>
    </div>
  );
}
export default AppSiteFooter;